export const finishMessageType = 'finish';
export const payModalName = 'pay-modal';
